import { Check, Users, Award, Shield } from 'lucide-react';
import { Card, SectionTitle } from '../../ui';

const highlights = [
    { icon: Users, text: 'Echipa de profesionisti cu peste 20 ani experienta' },
    { icon: Award, text: 'Partener francizat Renomia - broker CEE' },
    { icon: Shield, text: 'Toate tipurile de asigurari sub un singur acoperis' },
];

export function AboutUs() {
    return (
        <section className="py-12 md:py-16 bg-main-color">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <SectionTitle subtitle="Partenerul tau de incredere in asigurari" className="text-white [&>h2]:text-white [&>p]:text-white/80">Cine suntem?</SectionTitle>

                <div className="max-w-4xl mx-auto">
                    <Card variant="elevated" className="relative overflow-hidden">
                        {/* Decorative element */}
                        <div className="absolute top-0 right-0 w-32 h-32 bg-main-color/5 rounded-full -translate-y-1/2 translate-x-1/2" />

                        <div className="relative">
                            <p className="text-gray-700 font-font-s text-lg leading-relaxed mb-6 text-justify">
                                Suntem o societate de intermediere in asigurari, franciza{' '}
                                <span className="font-semibold text-main-color">
                                    Renomia Insurance Reinsurance Broker
                                </span>
                                , specializata sa va ofere solutii personalizate si adaptate nevoilor dumneavoastra.
                            </p>

                            <p className="text-gray-700 font-font-s text-lg leading-relaxed mb-8 text-justify">
                                Cu o echipa de profesionisti care au o experienta de peste 20 ani si parteneriat solid cu
                                unul dintre cei mai importanti brokeri de asigurari din CEE, va asiguram suportul necesar
                                pentru a lua cele mai bune decizii privind protejarea patrimoniului dvs.
                            </p>

                            <div className="border-t border-gray-100 pt-6">
                                <p className="text-center font-font-s text-xl font-bold text-main-color mb-6">
                                    Pe scurt: TOATE TIPURILE DE ASIGURARI!
                                </p>

                                <div className="grid md:grid-cols-3 gap-4">
                                    {highlights.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 hover:bg-main-color/5 transition-colors"
                                        >
                                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                                                <Check className="w-4 h-4 text-green-600" />
                                            </div>
                                            <span className="text-gray-700 font-font-s text-sm">{item.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </section>
    );
}
